import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    AsnHeaderSearchRequestParams,
    AsnHeaderViewModelCreateBody,
    AsnHeaderViewModelRead,
    AsnStatus,
    CarrierFragment,
    LocationFragment,
    ResourceAuth,
    VendorFragment,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';
import { AsnLineDto } from './asn-line.dto';

export type AsnHeaderRead = AsnHeaderViewModelRead & IEntity;
export type AsnHeaderCreate = AsnHeaderViewModelCreateBody;
export type AsnHeaderSearchParams = AsnHeaderSearchRequestParams &
    IPagedSearchParams;

export class AsnHeaderDto implements IEntity {
    constructor(data: Partial<AsnHeaderDto>) {
        Object.assign(this, data);
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    billOfLading?: string | null;
    resourceAuth?: ResourceAuth;
    externalReferenceId?: string | null;
    status?: AsnStatus;
    shipDateTime?: string | null;
    vendor?: VendorFragment;
    carrier?: CarrierFragment;
    originLocation?: LocationFragment;
    destinationLocation?: LocationFragment;
    customFields?: Array<CustomFieldDto> | null;
    lines?: Array<AsnLineDto> | null;
    trackingNumber?: string | null;
    expectedDateTime?: string | null;
}
